// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__BEn8I","accordion":"NavSection_accordion__55OXx","accordionDetails":"NavSection_accordionDetails__UI1Sm"};